import { useState } from "react";

export function Accordion({ children }) {
  return <div className="border border-white/20 border-b-0 rounded-md">{children}</div>;
}

export function AccordionItem({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-white/20">
      <button
        className="w-full text-left p-2 font-bold bg-background-back2"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
      </button>
      {isOpen && <div className="p-2">{children}</div>}
    </div>
  );
}
